import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { RootState } from '../../../store';
import { selectUserSub } from '../../../store/slices/auth.slice';
import { LocalStorage, ACCESS_TOKEN } from '../../../util/LocalStorage';

const emptyData = {
    slack: false,
    google: false,
    outlook: false,
    teams: false,
};

const useIntegrationsStatus = () => {
    const { t } = useTranslation('newNotifications');
    const toastHandler = useContainer(ToastStateHandler);
    const userApi = useContainer(UserApi);
    const storage: LocalStorage = useContainer(LocalStorage);
    const userSub = useSelector<RootState, string>(selectUserSub);
    const [isReady, setIsReady] = useState<boolean>(false);
    const [data, setData] = useState(emptyData);

    useEffect(() => {
        const accessToken = storage.get(ACCESS_TOKEN);

        if (!userSub || !accessToken) {
            setIsReady(true);
            return;
        }

        const getActivatedIntegrations = () => {
            const { exec, abort } = userApi.getIntegrationsStatus({
                onSuccess: res => {
                    setData(res.body);
                },
                onError: () => {
                    toastHandler.push('error', t('common.error'), t('common.somethingWentWrong'));
                },
                onFinally: () => setIsReady(true),
            });
            exec();
            return abort;
        };

        const abort = getActivatedIntegrations();
        return abort;
    }, [userSub]);

    return { data, isReady };
};

export default useIntegrationsStatus;
